import { FC } from 'react';
import { ServiceCard } from './ServiceCard';
import type { Service } from '../../types/service.types';

interface ServiceGridProps {
  services: Service[];
}

export const ServiceGrid: FC<ServiceGridProps> = ({ services }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
      {services.map((service) => (
        <ServiceCard key={service.id} service={service} layout="vertical" />
      ))}
    </div>
  );
};
